module.exports = __webpack_public_path__ + "img/A61-20190408_06.aa726911.jpg";